import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { getDaysLookup, getCardsStates } from '../api';
import SelectInput from 'src/components/shared/selectInput';
import Loader from 'src/components/loader.component';
import apiCalls from 'src/api/apiCalls';
import { numberFormat } from 'highcharts';
import { Alert } from 'antd';
import SeriesChart from '../seriesChart';
const chartProps = {
    type: "column",
    backgroundColor: "Transparent",
    height: 400,
    marginBottom: 100,
    marginTop: 30,
    style: {
        fontFamily: "Segoe UI",
    }
};
const otherOptions = {
    title: "",
    tooltip: {
        shared: true,
        valueSuffix: "",
    },
    legend: {
        enabled: true,
        layout: "horizontal",
        align: "center",
        verticalAlign: "bottom",
    },
    xAxis: {
        categories: [],
    },
    yAxis: {
        allowDecimals: false,
        title: {
            text: `<span class="text-valueColor">Count</span>`,
            useHTML: true
        },
        labels: {
            style: {
                color: '#FFFFFF'
            },
            formatter: function () {
                return `${numberFormat(this.value, 0, '.', ',')}`;
            }
        }
    },
    plotOptions: {
        column: {
            stacking: "normal",
            dataLabels: {
                enabled: false,
                format: "{y}",
            },
        },
    },
    credits: {
        enabled: false
    },
    exporting: {
        enabled: true,
    },
    lang: {
        thousandsSep: ',',
    },
};
const AllStatesCards = () => {
    const [days, setDays] = useState(null)
    const [filters, setFilters] = useState(null)
    const [gettingDays, setGettingDays] = useState(false);
    const [error, setError] = useState(null)
    useEffect(() => {
        setGettingDays(true)
        getDays()
    }, [])
    const getDays = async () => {
        try {
            const response = await getDaysLookup();
            if (response.ok) {
                setDays(response.data["Graph"])
                setFilters({ days: response.data["Graph"]?.[0]?.name })
            } else {
                setError(apiCalls.isErrorDispaly(response))
            }
        } catch (errorMsg) {
            setError(apiCalls.isErrorDispaly(errorMsg))
        } finally {
            setGettingDays(false)
        }
    }
    const handleFilterChange = useCallback((value) => {
        setFilters((prev) => ({ ...prev, "days": value }))
    }, [])
    const fetchParams = useMemo(() => {
        return [filters?.days?.replace(/\D/g, '')];
    }, [filters])
    const closeError = useCallback(() => {
        setError(null)
    }, [])
    return (<>
        <div className="">

            {error && <Alert
                className='mb-2'
                type="error"
                description={error}
                onClose={closeError}
                showIcon
                closable
            />}
            {!filters && <Loader />}
            {filters &&
                <>
                    <div className='flex justify-between items-center'>
                        <div className='md:w-40 ml-auto'><SelectInput className='text-whiteText' options={days} fieldName="days" loading={gettingDays} defaultValue={filters?.days} value={filters?.days} onChange={handleFilterChange} allowClear={false} showSearch={false} /></div>
                    </div>
                    <SeriesChart
                        shouldFetch={true}
                        chartProperties={chartProps}
                        fetchMethod={getCardsStates}
                        seriesKey={"transactionsModels"}
                        otherOptions={otherOptions}
                        axiskey={'yAxis'}
                        hasFetchParams={true}
                        fetchParams={fetchParams}
                        gettingFilters={gettingDays}
                    /></>}
        </div>
    </>);
}
export default React.memo(AllStatesCards)